import React, { useContext } from "react";
import { DataScienceContext } from "../context/DataScienceContext";
import { getAvailableIntervals } from "../utils/dataProcessing";

const optionStyle = {
  display: "block",
  width: "100%",
  padding: "6px 10px",
  border: "none",
  background: "transparent",
  textAlign: "left",
  fontSize: "0.875rem",
  cursor: "pointer",
  borderRadius: "4px",
};

const activeOptionStyle = {
  ...optionStyle,
  background: "var(--color-action-subtle, #e7f1ff)",
  color: "var(--color-action, var(--bs-primary, #0d6efd))",
  fontWeight: 600,
};

const hoverBg = "var(--color-action-subtle, #f0f6ff)";

function IntervalPicker() {
  const {
    startDate,
    endDate,
    customInterval,
    setCustomInterval,
    showIntervalPicker,
    setShowIntervalPicker,
  } = useContext(DataScienceContext);

  if (!showIntervalPicker) return null;

  const availableIntervals = getAvailableIntervals(startDate, endDate);
  const currentInterval = customInterval || Object.keys(availableIntervals)[0];
  const isAuto = !customInterval;

  const handleSelect = (value) => {
    setCustomInterval(value);
    setShowIntervalPicker(false);
  };

  return (
    <div
      style={{
        position: "absolute",
        top: "40px",
        right: "0",
        background: "var(--color-bg-surface, #fff)",
        border: "1px solid var(--color-border-default, #ccc)",
        borderRadius: "4px",
        padding: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        zIndex: 1000,
        minWidth: "200px",
      }}
    >
      <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "8px" }}>Data Interval</div>

      <div role="listbox" aria-label="Data Interval">
        {Object.entries(availableIntervals).map(([value, label]) => {
          const isActive = currentInterval === value && !isAuto;
          return (
            <button
              key={value}
              role="option"
              aria-selected={isActive}
              style={isActive ? activeOptionStyle : optionStyle}
              onClick={() => handleSelect(value)}
              onMouseEnter={(e) => {
                if (!isActive) e.currentTarget.style.background = hoverBg;
              }}
              onMouseLeave={(e) => {
                if (!isActive) e.currentTarget.style.background = "transparent";
              }}
            >
              {isActive ? `✓ ${label}` : label}
            </button>
          );
        })}
        <hr style={{ margin: "4px 0", borderColor: "var(--color-border-default, #ccc)" }} />
        <button
          role="option"
          aria-selected={isAuto}
          style={isAuto ? activeOptionStyle : optionStyle}
          onClick={() => handleSelect(null)}
          onMouseEnter={(e) => {
            if (!isAuto) e.currentTarget.style.background = hoverBg;
          }}
          onMouseLeave={(e) => {
            if (!isAuto) e.currentTarget.style.background = "transparent";
          }}
        >
          {isAuto ? "✓ Auto (Default)" : "Auto (Default)"}
        </button>
      </div>

      <button
        onClick={() => setShowIntervalPicker(false)}
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          border: "none",
          background: "transparent",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        ×
      </button>
    </div>
  );
}

export default IntervalPicker;
